import { create } from "zustand";

type Props = {
  title: string | null;
  onOpen: (title: string) => void;
  onClose: () => void;
};

export const useClientStoriesModal = create<Props>()((set) => ({
  title: null,
  onOpen: (title) => set({ title }),
  onClose: () => set({ title: null }),
}));
